<template lang="pug">
  v-container(fluid)
    v-layout(row wrap v-if="!readonly")
      v-flex.display-2(xs12 sm4) Cart
      v-flex(xs12 sm8)
        selected-event
    v-layout(row v-if="count == 0")
      div.display-1 Your cart is empty
    v-layout(row wrap v-else)
      v-flex(xs12)
        v-card.pa-2
          v-list
           
            template(v-for="(item, index) in packages" )
              v-layout.py-1(row :class="{error: !checkPackage(item)}")
                v-flex(xs12)
                  v-layout(row)
                    v-flex(xs3 sm2 )
                      v-img.mx-1(:src="imageBase+item.imageURL+'?alt=media'" max-height="150px" contain v-if="item.imageURL")
                    v-flex(xs4) 
                      v-layout(row wrap)
                        v-flex.title(xs12) {{item.packageName}} 
                        v-flex.warning.pa-1.white--text(xs12 v-if="!checkPackage(item)" ) This package is for 
                          strong {{getEventName(item.eventId)}} 
                          span and cannot be processed with this order. Please delete it or change your selected event
                          v-layout(row)
                            v-btn.error(@click="deletePackage(item)") Delete 
                        v-flex(xs12 v-if="showCOBtn")
                          v-btn(@click="deletePackage(item)" icon small color="red" dark) 
                            v-icon delete 
                    v-flex.right(xs2) ${{item.cost}} 

                    v-flex(xs4)
                      div(v-if="showCOBtn") 
                        number-input.right(:val="item.amount" @increment="incrementAmount(item)" @decrement="decrementAmount(item)")    
                      div.right(v-else) {{item.amount}}        
              v-divider
            template(v-for="(item, index) in items")
              v-layout.py-1(row)
                v-flex(xs12)
                  v-layout(row)
                    v-flex(xs2 sm2 )
                      v-img(:src="imageBase+item.imageURL+'?alt=media'" max-height="100px" contain v-if="item.imageURL")
                    v-flex(xs4) 
                      v-layout(row wrap)
                        v-flex.title(xs12) {{item.itemName}} 
                        v-flex(xs12 v-if="showCOBtn")
                          v-btn(@click="deleteItem(item)" icon small color="red" dark) 
                            v-icon delete
                    v-flex.right(xs2) ${{item.cost}} 

                    v-flex(xs4) 
                      div(v-if="showCOBtn")
                        number-input.right(:val="item.amount" @increment="incrementAmount(item)" @decrement="decrementAmount(item)" )  
                      div.right(v-else) {{item.amount}}        
              v-divider
          v-container
            v-layout.title(row)
              v-flex(xs8) Convenience fee
              v-flex.text-xs-right(xs4 class="cost") ${{convenienceFee}} 
            v-layout.display-1(row)
              v-flex(xs8) Total
              v-flex.text-xs-right(xs4 class="cost") ${{totalCost}} 
      v-flex.my-2(xs12 v-if="!readonly")
        v-card.pa-3
          div 
            span Add a disposable cooler to your order for $50 TT
            addToCartBtn(:item="disposableCooler", itemType="item" @added="updateCart()")

      v-flex(xs12 class="text-xs-right" v-if="showCOBtn")
        v-btn(color="orange" dark @click="checkout" ) 
          span(v-if="$route.path !='/checkout'") Checkout 
          span(v-if="$route.path =='/checkout'") Next 
      v-flex.pa-2.text-xs-right(xs12 v-else ) {{error}}
        v-btn(to="/events" color="primary" v-if="!readonly") Select an event



      
</template>
<script>
import SelectedEvent from "../components/SelectedEvent"
import NumberInput from '../components/NumberInput'
import AddToCartBtn from '../components/AddToCartBtn'
export default {
  name: "Cart",
  props:{
    showCheckoutBtn:{
      default: true
    },
    readonly:{
      default: false
    }
  },
  data:()=>({
    items:[],
    packages:[],
    error: ""
  }),
  components:{NumberInput, SelectedEvent, AddToCartBtn},
  computed:{
    convenienceFee(){
      return this.$store.state.convenienceFee
    },
    imageBase(){return this.$store.state.baseImageURL +'th'},
    count(){
      let amt = 0 
      if (this.$store.state.cart){
        let cart = this.$store.state.cart
        amt = cart.items.length + cart.packages.length
      }
      return amt
    },
    hasPackages(){
      return this.$store.state.cart.packages.length > 0 ? true : false
    },
    disposableCooler(){
      //TODO: find a better way to display suggested items in the cart
      let cooler = {}
      try{
        cooler = this.$store.state.items.filter(i=>{
          return i.id === '-LYoixUIyNCHqnvwVaIN'
        })[0]
        cooler.amount = 1
        cooler = JSON.parse(JSON.stringify(cooler))
      }catch(err){
        console.log(e.message)
      }finally{
        return cooler
      }
      
    },
    showCOBtn(){
      if (this.showCheckoutBtn === true){
        if (this.$route.path==="/cart" || this.$route.path==="/checkout"){
          if(this.$store.state.cart.selectedEvent==null){
            this.error= "You must select an event to checkout"
            // console.log("event not selected")
            return false
          }else if(this.hasPackages){
            // console.log("inside has packages")
            let flag = true
            this.$store.state.cart.packages.forEach(p=>{
              if (flag ===true){
                flag = p.eventId !== this.$store.state.cart.selectedEvent ? false : true
              }
            })
            // console.log(flag)
            return flag
          }else{
            return true
          }
        }else{
          return true
        }
        
      }else{
        return  (this.showCheckoutBtn === 'true') ? true : false
      }
    },
    // items(){
    //   return this.$store.state.cart.items
    // },
    // packages(){
    //   return this.$store.state.cart.packages
    // },
    totalCost(){
      let total = 0
      total += this.convenienceFee 
        this.$store.state.cart.packages.forEach(p=>{
          total += p.cost * p.amount
        })
        this.$store.state.cart.items.forEach(i=>{
          total += i.cost * i.amount
        })
      return total
    }

  },
  created(){
    this.updateCart()
  },
  methods:{
    deletePackage(item){
      this.$store.dispatch('deletePackageFromCart', item)
      this.updateCart()
    },
    deleteItem(item){
      this.$store.dispatch('deleteItemFromCart', item)
      this.updateCart()
    },
    incrementAmount(item){
      this.$store.dispatch('incrementAmountInCart', item)
      this.updateCart()
    },
    decrementAmount(item){
      if(item.amount > 1){
        this.$store.dispatch('decrementAmountInCart', item)
      }
      this.updateCart()
    },
    updateCart(){
      let that = this
      setTimeout(()=>{
        that.items ={...that.$store.state.cart.items}
        that.packages = that.$store.state.cart.packages
      }, 200)
      
    },
    checkout(){
      if(this.$route.path == "/checkout"){
        this.$emit('next')
      }else{
        if (this.$store.state.loggedin == true){
          this.$router.push("/checkout")  
        } else{
          this.$router.push("/login")  
        }
      }
    },
    checkPackage(p){
      if (this.hasPackages && this.$store.state.cart.selectedEvent != null){
        if (p.eventId === this.$store.state.cart.selectedEvent){
          return true
        }else{
          return false
        }
      }
    },
    getEventName(id){
      let event = this.$store.state.events.filter(e=>{
        // console.log(e)
        return e.id === id
      })
      return event[0].eventName
      
    }
  }
}
</script>
<style scoped>
.right{
  text-align: right;
}
.error{
  background-color: #E57373;
}
</style>

